<template>
  <el-dialog @close="onClose" :footer="null" top="0px" :title="null" :show-close="false" :visible.sync="dialogVisible" width="1000px">
    <div id="container"></div>
  </el-dialog>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  data() {
    return {
      map: null,          // 地图实例
      geocoder: null,     // 地理编码实例,
      address: "",        // 输入的地址
      location: null,     // 解析后的坐标 { lng, lat }
      dialogVisible: false
    }
  },
  methods: {
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "06578c51579f7b499c18d9bab5228f71",
      };
      AMapLoader.load({
        key: "8d5ae35f69c72cae8ade593421c6d366", // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ["AMap.Scale", "AMap.Geocoder"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "2D", // 是否为3D地图模式
            zoom: 18, // 初始化地图级别
            center: [116.397428, 39.90923], // 初始化地图中心点位置
          });

          this.geocoder = new AMap.Geocoder({
            city: "全国", // 限定城市，默认全国
          });

          this.$nextTick(() => {
            this.searchByAddress();
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 通过地址搜索位置
    searchByAddress() {
      if (!this.geocoder || !this.address.trim()) return;
      // 调用地理编码API
      this.geocoder.getLocation(this.address, (status, result) => {
        if (status === "complete" && result.info === "OK") {
          const { lng, lat } = result.geocodes[0].location;
          this.location = { lng, lat };
          var circle = new AMap.Circle({
            center: [lng, lat],
            radius: 1000, //半径
            borderWeight: 1,
            strokeOpacity: 1,
            strokeWeight: 6,
            strokeOpacity: 0,
            fillOpacity: 0.4,
            strokeStyle: 'solid',
            strokeDasharray: [10, 10],
            // 线样式还支持 'dashed'
            fillColor: '#1791fc',
            zIndex: 50,
          })

          this.map.add(circle);
          // 缩放地图到合适的视野级别
          this.map.setFitView([circle]);
          new AMap.Marker({
            position: [lng, lat],
            map: this.map,
          });
          var infoWindow = new AMap.InfoWindow({
            content: `<div class="amap-info-content amap-info-outer">${this.address}</div>`,
            anchor: "bottom-center",
            isCustom: true,
            offset: new AMap.Pixel(0, -35)
          });
          //打开信息窗体
          infoWindow.open(this.map, [lng, lat]); //map 为当前地图的实例，map.getCenter() 用于获取地图中心点坐标。
          // 在地图上标记位置
          this.map.setCenter([lng, lat]);
        } else {
          console.error("地址解析失败:", result);
          this.$message.error("地址解析失败，请检查输入！");
        }
      });
    },
    onOpen(address) {
      this.address = address;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initAMap();
      });
    },
    onClose() {
      this.map = null;
      this.geocoder = null;
      this.address = "";
      this.location = null;
    }
  }
}
</script>

<style lang="less" scoped>
#container {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 600px;
}

/deep/ .el-dialog {
  top: 50%;
  transform: translateY(-50%);

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}

/deep/ .el-link {
  vertical-align: top;
}
</style>